import businessIcon from "../../../../assets/images/member/buisness-icon.svg";
import {ChangeEvent} from "react";

export default function CompanyInfo(props: any) {
    const changeHandle = (event: ChangeEvent<HTMLInputElement>) => {
        props.onChangeCompanyInfo(event.target.name, event.target.value);
    }

    return (
        <div className="member-buisness-box">
            <div className="box-title">
                <img src={businessIcon} alt="icon"/>
                <div className="text">
                    사업자정보
                </div>
            </div>
            <div className="box-information">
                <div className="title">
                    회사명
                </div>
                <input
                    name="companyName"
                    defaultValue={props.user.companyName}
                    onChange={changeHandle}
                    className="text"
                />
            </div>

            <div className="box-information">
                <div className="title">
                    사업자등록번호
                </div>
                <input
                    name="businessNumber"
                    defaultValue={props.user.businessNumber}
                    onChange={changeHandle}
                    className="text"
                />
            </div>
            <div className="box-information">
                <div className="title">
                    업태/업종
                </div>
                <input
                    name="companyType"
                    defaultValue={props.user.companyType}
                    onChange={changeHandle}
                    className="text"
                />
            </div>
        </div>
    );
}